module.exports = __webpack_public_path__ + "static/assets/617dd0f2b2f2be576184b4283a3c917f.svg";